import React from "react";
import ReactDOM from "react-dom";
import * as serviceWorker from "./serviceWorker";
import App from "App";
import { createRoot } from "react-dom/client";
import "./global";
import "./polyfills";

const container = document.getElementById("root");
const root = createRoot(container);
root.render(<App />);
serviceWorker.unregister();
